import React, { Component } from 'react';
import { Provider } from 'react-redux';

import ScreensRoot from 'screens/Root';
import { Favicon } from 'components/misc';
import configureStore from 'redux/configureStore';

const store = configureStore();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Favicon />

        <ScreensRoot />
      </Provider>
    );
  }
}

export default App;
